const createTimeElement = ({
  datetime,
  displayText,
  allowHTML = false
}) => {
  if (!datetime || !displayText) {
    return null;
  }
  const timeElement = document.createElement("time");
  timeElement.setAttribute("datetime", datetime);
  if (allowHTML) {
    timeElement.innerHTML = displayText;
  } else {
    timeElement.textContent = displayText;
  }
  return timeElement;
};
export {
  createTimeElement
};
//# sourceMappingURL=createTimeElement.js.map
